import React from 'react';
import { FTUEWrapperProps } from '../../types/ftue.types';
import { useFTUE } from '../../contexts/FTUEContext';

export const FTUEWrapper: React.FC<FTUEWrapperProps> = ({
  children,
  stepId,
  className = '',
}) => {
  const { state } = useFTUE();
  
  // Check if this wrapper corresponds to the current FTUE step
  const isCurrentStep = state.isActive && 
    state.steps[state.currentStepIndex]?.id === stepId;

  // Add highlighting class if this is the current step
  const wrapperClassName = `${className} ${isCurrentStep ? 'ftue-highlighted-element' : ''}`.trim();

  return (
    <div className={wrapperClassName} data-ftue-step={stepId}>
      {children}
    </div>
  );
};
